import { Component } from '@angular/core';

@Component({
  selector: 'maplix-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'maplix-survey-viewer';
}
